import React from 'react';

export default function NotFound() {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.errorCode}>404</h1>        
        <p style={styles.description}>
        This page could not be found.
        </p>
        <button 
          style={styles.button}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#3a3a3a';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#2a2a2a';
          }}
          onClick={() => window.location.href = '/'}
        >
          Homepage
        </button>
      </div>
      
      <div style={styles.decorativeElements}>
        <div style={{...styles.circle, ...styles.circle1}}></div>
        <div style={{...styles.circle, ...styles.circle2}}></div>
        <div style={{...styles.circle, ...styles.circle3}}></div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    color: '#ffffff',
    position: 'fixed',
    overflow: 'hidden',
    padding: '20px',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  content: {
    textAlign: 'center',
    zIndex: 2,
    
  },
  errorCode: {
    fontSize: '120px',
    fontWeight: '700',
    margin: '0',
    background: 'linear-gradient(135deg, rgb(173 173 176) 0%, rgb(113 110 117) 100%) text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    letterSpacing: '-5px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '600',
    margin: '20px 0',
    color: '#e0e0e0',
  },
  description: {
    fontSize: '16px',
    color: '#999999',
    marginBottom: '40px',
    lineHeight: '1.6',
  },
  button: {
    backgroundColor: '#2a2a2a',
    color: '#ffffff',
    border: '1px solid #3a3a3a',
    padding: '14px 32px',
    fontSize: '16px',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontWeight: '500',
  },
  decorativeElements: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 1,
    pointerEvents: 'none',
  },
  circle: {
    position: 'absolute',
    borderRadius: '50%',    
  },
  circle1: {
    width: '400px',
    height: '400px',
    top: '-200px',
    right: '-200px',
  },
  circle2: {
    width: '300px',
    height: '300px',
    bottom: '-150px',
    left: '-150px',
  },
  circle3: {
    width: '250px',
    height: '250px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    opacity: 0.5,
  },
};